import React, { useState, useContext } from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';

const LoadingContext = React.createContext();

const Loading = () => {
  const { loading } = useContext(LoadingContext);
  return <div>{loading && <LinearProgress color="secondary" />}</div>;
};

const LoadingProvider = props => {
  const [loading, setLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {props.children}
    </LoadingContext.Provider>
  );
};
export { Loading, LoadingProvider, LoadingContext };
